// extracted by mini-css-extract-plugin
export default {"appBar":"AppBar_appBar__xXgRm","title":"AppBar_title__cn-nD"};